import { baseActions, baseMutations } from '../base'
import { apiAxios, parseFilters } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import { getEntityFilters } from '@/helpers/permissions'

const initialState = () => {
  return {
    module: 'entities',
    model: 'entity',
    loading: false,
    list: [],
    selectList: [],
    cameras: [],
    selected: {
      active: true,
      isCustomer: false,
      is4g: false,
      name: '',
      odooId: '',
      telf: [],
      web: '',
      email: '',
      address: '',
      cp: '',
      countryId: {},
      provinceId: {},
      townId: {},
      color: '',
      facebook: '',
      twitter: '',
      instagram: '',
      stadiumId: [],
      // logo: 'default-team.png',
      homeImg: '',
    },
    idSelected: '',
    filters: {},
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => ({
      ...item,
      createdAt: formatDate(item.createdAt, true),
    }))
  },
  cameras(state) {
    return state.cameras.map((item) => ({
      ...item,
      checkAt: formatDate(item.checkAt, true),
    }))
  },
}

const actions = {
  ...baseActions,
  async fetchList({ commit, state }, params = {}) {
    let { body, query } = parseFilters(state, params, getEntityFilters(params))

    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))

    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async fetchSelectList({ commit, state }, params = {}) {
    let set = true
    let body
    let query = {}
    if (params.set === false) {
      set = false
      delete params.set
    }

    if (params.fetchData) {
      delete params.fetchData
      body = Object.assign({}, params, getEntityFilters(params))
    } else {
      delete params.fetchData
      body = Object.assign({}, params)
    }

    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/select', body, { params: query })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    if (set) commit('setSelectList', list)
    return list
  },
  async fetchCameras({ commit, state }, entityId) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .get(`${state.module}/${entityId}/cameras`)
      .finally(() => commit('setLoading', false))
    const list = data.data ? data.data.cameras : []
    commit('setCameras', list)
    return list
  },
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  setCameras(state, payload) {
    state.cameras = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.cameras.push(item))
    }
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
    state.cameras = []
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
